import {
  TYPE_BOAT_1, TYPE_BOAT_2, TYPE_BOAT_3, TYPE_BOAT_TRAILER,
  TYPE_BUS,
  TYPE_BUS_AUTOBUS, TYPE_CAMPER, TYPE_CAMPER_MINI,
  TYPE_CAR_COMBI,
  TYPE_CAR_HATCHBACK_3,
  TYPE_CAR_HATCHBACK_5,
  TYPE_CAR_PICKUP,
  TYPE_CAR_SEDAN,
  TYPE_CAR_SUV,
  TYPE_MOTORCYCLE, TYPE_MOTORCYCLE_CHOPPER, TYPE_QUAD, TYPE_SCOOTER,
  TYPE_TRAILER,
  TYPE_TRUCK,
  TYPE_TRUCK_MINI,
  TYPE_TRUCK_SEMI,
  TYPE_VAN,
  TYPE_VAN_MINI
} from "./vehicleDamagesImagePatternByType";

export const vehicleDamagesTypesByCarType = (carTypeId) => {
  return {
    1: [
      TYPE_CAR_SEDAN,
      TYPE_CAR_HATCHBACK_3,
      TYPE_CAR_HATCHBACK_5,
      TYPE_CAR_COMBI,
      TYPE_CAR_SUV,
      TYPE_CAR_PICKUP,
    ],
    2: [
      TYPE_VAN,
      TYPE_VAN_MINI,
    ],
    3: [
      TYPE_TRUCK_SEMI,
    ],
    4: [
      TYPE_TRAILER,
    ],
    5: [
      TYPE_TRUCK,
      TYPE_TRUCK_MINI,
    ],
    6: [
      TYPE_BUS,
      TYPE_BUS_AUTOBUS,
    ],
    20: [
      TYPE_MOTORCYCLE,
      TYPE_MOTORCYCLE_CHOPPER,
    ],
    21: [
      TYPE_BOAT_1,
      TYPE_BOAT_2,
      TYPE_BOAT_3,
      TYPE_BOAT_TRAILER,
    ],
    30: [
      TYPE_QUAD,
    ],
    31: [
      TYPE_SCOOTER,
    ],
    36: [
      TYPE_CAMPER,
      TYPE_CAMPER_MINI,
    ],
  }[carTypeId] ?? []
}